import PropTypes from "prop-types"
import { Empty, Typography } from "antd"

const ShowMessage = ({message, src, title, sx, children, ...restProps}) => {
  const img = src || Empty.PRESENTED_IMAGE_SIMPLE
  return <Empty image={img} description={
    <>
      {title && (
        <Typography.Title
          level={5}
        >
          {title}
        </Typography.Title>
      )}
      {message && (
        <Typography.Text type="secondary">
          {message}
        </Typography.Text>
      )}
    </>
  } />
}

ShowMessage.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  sx: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

ShowMessage.defaultProps = {
  title: "Empty!!",
  message: "Result not found",
  sx: {},
  children: null,
}

export default ShowMessage
